import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'IsIndeterminate', pure: false })
export class IsIndeterminate implements PipeTransform {
    transform(value: any): boolean {
      return Object.values(value).some((element: boolean) => element) && !Object.values(value).every((element: boolean) => element);
    }
}
